<template>
  <div id="home">
    <div class="swiperContent" v-for="item in swiperList" :key="item.id">
      <div class="content" >
        <!-- <div class="title">{{item.pageAreaName}}</div> -->
        <swiper class="scrollItem" :options="{autoHeight:true,loop: true,autoplay:{disableOnInteraction: false,delay: item.rotationRate}}" style="width:100%;">
          <swiper-slide v-for="i in item.pageShowList" :key="i.id" style="width: 100%;">
            <a :href="i.jumpLink" style="font-size: 0;">
              <img
                class="swiperImg"
                :src="`${uploadUrl}${i.imgUrl}`"
                alt="图片"
                style="width: 100%;height: 100%;"
              />
            </a>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "home",
  data() {
    return {
      uploadUrl: "",
      swiperList: [],
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  created() {},
  mounted() {
    document.title = "首页";
    this.uploadUrl = apis.uploadUrl;
    this.getDataList(this.uploadUrl);
  },
  methods: {
    // 获取数据
    getDataList() {
      // const json = {
      //   page: 1,
      //   pageSize: 20
      // };
      apis.homeAreaList().then(res => {
        if (res.code === 200) {
          this.swiperList = res.data.map(item => {
            item.pageShowList.map(i => {
              if (i.jumpLink.indexOf("http") !== -1) {
                i.jumpLink = "http" + i.jumpLink.split("http")[1];
              }
              if (i.jumpLink.indexOf("https") !== -1) {
                i.jumpLink = "https" + i.jumpLink.split("https")[1];
              }
              return i;
            });
            return item;
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #home {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #home {
    width: 276px * $zoom;
  }
}
#home {
  font-size: 16px * $zoom;
  margin: auto;
  .swiperContent {
    .content {
      display: flex;
      align-items: center;
      flex-direction: column;
      .title {
        height: 75px;
        font-size: 30px;
        line-height: 75px;
      }
    }
  }
}
</style>
